import React from 'react';
import { services } from '../data/mock';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowRight, CheckCircle2 } from 'lucide-react';

const ServicesPage = () => {
    return (
        <div className="min-h-screen">
            {/* Hero Section */}
            <section className="pt-32 pb-16 bg-gradient-to-br from-cream-50 via-white to-brand-light/20">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                    <span className="text-brand-primary font-semibold text-sm uppercase tracking-wider">
                        Our Expertise
                    </span>
                    <h1 className="mt-4 text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                        Comprehensive <span className="text-brand-primary">Interior Solutions</span>
                    </h1>
                    <p className="mt-6 text-lg text-gray-600 max-w-2xl mx-auto">
                        From conceptualization to execution, we provide end-to-end interior design services tailored to your lifestyle and budget.
                    </p>
                </div>
            </section>

            {/* Services Grid */}
            <section className="py-20 bg-white">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                        {services.map((service) => (
                            <div
                                key={service.id}
                                className="group bg-gray-50 rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-500 border border-gray-100"
                            >
                                <div className="relative h-64 overflow-hidden">
                                    <img
                                        src={service.image}
                                        alt={service.title}
                                        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                                </div>
                                <div className="p-8">
                                    <h3 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-brand-primary transition-colors">
                                        {service.title}
                                    </h3>
                                    <p className="text-gray-600 mb-6 line-clamp-3">
                                        {service.description}
                                    </p>
                                    <ul className="space-y-3 mb-8">
                                        {service.features.slice(0, 3).map((feature, idx) => (
                                            <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                                                <CheckCircle2 className="w-4 h-4 text-brand-primary mt-0.5" />
                                                <span>{feature}</span>
                                            </li>
                                        ))}
                                    </ul>
                                    <Link to={`/services/${service.slug}`}>
                                        <Button variant="outline" className="w-full border-brand-primary text-brand-primary hover:bg-brand-primary hover:text-white rounded-xl py-6">
                                            View Details
                                            <ArrowRight className="w-4 h-4 ml-2" />
                                        </Button>
                                    </Link>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

        </div>
    );
};

export default ServicesPage;
